module.exports = __webpack_public_path__ + "img/us-nm.129661a9.svg";